// 授权状态枚举
export const AuthStatus = {
  TERMINATED: -2, // 授权已解约
  REJECTED: -1, // 材料已驳回
  OPENING_SUB_ACCOUNT: 1, // 子户开通中
  PENDING_PLATFORM_CONFIG: 2, // 待网约平台配置
  PENDING_QIANSAN_CONFIG: 3, // 待乾三配置
  PENDING_CONFIRM: 4, // 授权配置待确认
  PENDING_ACTIVE: 5, // 授权待生效
  ACTIVE: 6, // 授权生效中
}

// 状态对应的文本描述
export const AuthStatusMap = {
  [AuthStatus.TERMINATED]: '授权已解约',
  [AuthStatus.REJECTED]: '材料已驳回',
  [AuthStatus.OPENING_SUB_ACCOUNT]: '子户开通中',
  [AuthStatus.PENDING_PLATFORM_CONFIG]: '待网约平台配置',
  [AuthStatus.PENDING_QIANSAN_CONFIG]: '账户配置中',
  [AuthStatus.PENDING_CONFIRM]: '授权配置待确认',
  [AuthStatus.PENDING_ACTIVE]: '授权待生效',
  [AuthStatus.ACTIVE]: '授权生效中',
}
